"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectImageMimeType = detectImageMimeType;
exports.decodeBase64Image = decodeBase64Image;
exports.mimeToExtension = mimeToExtension;
exports.computeImageRef = computeImageRef;
exports.readImagePixelSize = readImagePixelSize;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const base64_1 = require("../Utils/base64");
function detectImageMimeType(data) {
    if (data[0] === 0x89 && data[1] === 0x50 && data[2] === 0x4e && data[3] === 0x47) {
        return 'image/png';
    }
    if (data[0] === 0xff && data[1] === 0xd8) {
        return 'image/jpeg';
    }
    if (data[0] === 0x42 && data[1] === 0x4d) {
        return 'image/bmp';
    }
    return 'application/octet-stream';
}
function decodeBase64Image(base64) {
    const cleaned = base64.replace(/\s/g, '');
    const data = (0, base64_1.base64ToUint8Array)(cleaned);
    const mimeType = detectImageMimeType(data);
    return { data, mimeType };
}
function mimeToExtension(mimeType) {
    switch (mimeType) {
        case 'image/png':
            return 'png';
        case 'image/jpeg':
            return 'jpg';
        case 'image/bmp':
            return 'bmp';
        default:
            return 'bin';
    }
}
function computeImageRef(sourceIdentifier, mimeType) {
    const hash = sigma_engine_shared_1.Utils.fnv1aHash(sourceIdentifier);
    const ext = mimeToExtension(mimeType);
    return `images/${hash}.${ext}`;
}
function readImagePixelSize(data, mimeType) {
    switch (mimeType) {
        case 'image/png':
            return readPngPixelSize(data);
        case 'image/jpeg':
            return readJpegPixelSize(data);
        case 'image/bmp':
            return readBmpPixelSize(data);
        default:
            return null;
    }
}
function readPngPixelSize(data) {
    const IHDR_END = 24;
    if (data.length < IHDR_END) {
        return null;
    }
    const isIhdr = data[12] === 0x49 && data[13] === 0x48 && data[14] === 0x44 && data[15] === 0x52;
    if (!isIhdr) {
        return null;
    }
    const width = readUint32BE(data, 16);
    const height = readUint32BE(data, 20);
    return width > 0 && height > 0 ? { width, height } : null;
}
const JPEG_SOF_MARKERS = new Set([0xc0, 0xc1, 0xc2, 0xc3, 0xc5, 0xc6, 0xc7, 0xc9, 0xca, 0xcb, 0xcd, 0xce, 0xcf]);
function readJpegPixelSize(data) {
    let offset = 2;
    while (offset + 9 < data.length) {
        if (data[offset] !== 0xff) {
            offset++;
            continue;
        }
        const marker = data[offset + 1];
        if (marker === 0xff) {
            offset++;
            continue;
        }
        if (JPEG_SOF_MARKERS.has(marker)) {
            const height = (data[offset + 5] << 8) | data[offset + 6];
            const width = (data[offset + 7] << 8) | data[offset + 8];
            return width > 0 && height > 0 ? { width, height } : null;
        }
        const segmentLength = (data[offset + 2] << 8) | data[offset + 3];
        if (segmentLength < 2) {
            return null;
        }
        offset += 2 + segmentLength;
    }
    return null;
}
function readBmpPixelSize(data) {
    const DIB_HEADER_OFFSET = 14;
    const CORE_HEADER_SIZE = 12;
    const INFO_HEADER_SIZE = 40;
    if (data.length < DIB_HEADER_OFFSET + 4) {
        return null;
    }
    const headerSize = readUint32LE(data, DIB_HEADER_OFFSET);
    if (data.length < DIB_HEADER_OFFSET + headerSize) {
        return null;
    }
    if (headerSize === CORE_HEADER_SIZE) {
        const width = readUint16LE(data, 18);
        const height = readUint16LE(data, 20);
        return width > 0 && height > 0 ? { width, height } : null;
    }
    if (headerSize >= INFO_HEADER_SIZE) {
        const width = readInt32LE(data, 18);
        const height = Math.abs(readInt32LE(data, 22));
        return width > 0 && height > 0 ? { width, height } : null;
    }
    return null;
}
function readUint32BE(data, offset) {
    return ((data[offset] << 24) | (data[offset + 1] << 16) | (data[offset + 2] << 8) | data[offset + 3]) >>> 0;
}
function readUint32LE(data, offset) {
    return (data[offset] | (data[offset + 1] << 8) | (data[offset + 2] << 16) | (data[offset + 3] << 24)) >>> 0;
}
function readInt32LE(data, offset) {
    return readUint32LE(data, offset) | 0;
}
function readUint16LE(data, offset) {
    return data[offset] | (data[offset + 1] << 8);
}
//# sourceMappingURL=imageAssets.js.map